import { AuthToolsService } from './../auth-tools.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ConsoleLogger } from '../../../core/utilities/console-logger';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-set-user-password',
  templateUrl: './set-user-password.component.html',
  styleUrls: ['./set-user-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SetUserPasswordComponent implements OnInit {
  isSaving = false;
  userEmail = '';
  newPassword = '';

  constructor(private authToolsService: AuthToolsService, private toastrService: ToastrService) { }

  ngOnInit() {
  }

  save() {
    this.isSaving  = true;

    this.authToolsService.setUserPassword(this.userEmail, this.newPassword)
      .pipe(finalize(() => this.isSaving = false))
      .subscribe(x => {
        ConsoleLogger.logInfo(x);
        this.toastrService.success("User Password was updated successfully.");
      },
      (err)=>{
        console.error('Error:', err);
        this.toastrService.error("User Password update failed.");
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/developer/auth-tools/set-user-password/set-user-password.component.ts